/* ============================================================
   MCH KARTE — NOĆNI PROGRAM · choreography + UI
   One master ScrollTrigger-scrubbed timeline drives the whole
   show; every beat is a pure function of progress (reversible,
   deterministic — no internal state). karte3d.js owns the stage.
   Wordless scroll: the only copy lives in hero + buy.
   Debug: ?fast=1 (no smoothing) · ?p=0.42 (jump to progress)
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.MCHK_CONFIG || {};
  var MAN = window.MCHK_CARDS || { cards: [] };
  var qs = new URLSearchParams(location.search);
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 899px)').matches || 'ontouchstart' in window && window.innerWidth < 1100;

  var stage = document.getElementById('mchk-stage');
  var pinWrap = document.getElementById('mchk-scroll');
  var glMount = document.getElementById('mchk-gl');
  var pre = document.getElementById('mchk-pre');
  var body = document.body;
  var DBG = qs.get('dbg') === '1';

  /* on-device debug overlay — Safari console isn't reachable via simctl, so
     surface boot state on-screen when ?dbg=1 */
  function dbg(msg) {
    if (!DBG) return;
    var el = document.getElementById('mchk-dbg');
    if (!el) {
      el = document.createElement('pre');
      el.id = 'mchk-dbg';
      el.style.cssText = 'position:fixed;left:6px;top:80px;z-index:9999;margin:0;padding:8px 10px;max-width:92vw;background:rgba(0,0,0,.82);color:#6f6;font:11px/1.4 monospace;white-space:pre-wrap;border:1px solid #6f6;border-radius:6px;pointer-events:none';
      document.body.appendChild(el);
    }
    el.textContent += msg + '\n';
  }
  if (DBG) {
    dbg('gsap=' + !!window.gsap + ' ST=' + !!window.ScrollTrigger + ' THREE=' + !!window.THREE);
    dbg('reduced=' + reduced + ' mobile=' + mobile + ' stage=' + !!stage);
    dbg('vw=' + window.innerWidth + ' vh=' + window.innerHeight + ' dpr=' + window.devicePixelRatio);
    dbg('glMount=' + (glMount ? glMount.clientWidth + 'x' + glMount.clientHeight : 'null'));
    window.addEventListener('error', function (e) { dbg('window.error: ' + (e.message || e)); });
  }

  /* ---------- static fallback (reduced motion / no GL / no libs) ---------- */
  function staticMode(why) {
    dbg('STATIC: ' + (why || '?'));
    body.classList.add('mchk-static');
    if (pre) pre.remove();
    var canvases = glMount ? glMount.querySelectorAll('canvas') : [];
    for (var i = 0; i < canvases.length; i++) canvases[i].remove();
  }

  if (!window.gsap || !window.ScrollTrigger || !window.THREE || reduced || !stage) {
    staticMode('libs/reduced/stage guard');
    wireBuy(null);
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  /* ---------- engine boot ---------- */
  var eng = MCHK3D.create({ container: glMount, boxFrac: mobile ? 0.33 : 0.44, mobile: mobile });
  if (!eng) { staticMode('MCHK3D.create returned null (no WebGL)'); wireBuy(null); return; }
  dbg('engine created OK');

  var BOX = MCHK3D.BOX, CARD = MCHK3D.CARD;

  /* card list with suit/rank metadata; gold card flagged.
     HD textures only where the camera gets close — the four court heroes
     and the golden card (desktop only); everything else ships SD. */
  var HD_IDS = { 'k-spade': 1, 'q-heart': 1, 'j-club': 1, 'a-diamond': 1, 'star-gold': 1 };
  var cards = MAN.cards.map(function (c) {
    var m = c.id.match(/^(a|[2-9]|10|j|q|k|star)-(spade|diamond|club|heart|gold)$/) || [];
    var useHd = !mobile && c.hd && HD_IDS[c.id];
    return {
      id: c.id, src: useHd ? c.hd : c.file, px: useHd ? 1024 : (mobile ? 448 : 512),
      rank: m[1] || 'x', suit: c.id === 'star-gold' ? 'gold' : (m[2] || 'x'),
      gold: c.id === 'star-gold'
    };
  }).filter(function (c) { return c.id !== 'back'; });

  var backEntry = MAN.cards.filter(function (c) { return c.id === 'back'; })[0];

  var progressEl = document.getElementById('mchk-progress');

  /* ---------- boot escape hatches ----------
     boot() waits on ~64 texture loads. A request that *fails* is handled
     (every loadImage falls back), but one that *stalls* — flaky mobile, a
     dropped CDN socket — settles neither way, so .then/.catch never fire and
     #mchk-pre (fixed, z-index 200, opaque) traps the customer forever.
     Three layers, cheapest first:
       1. skip button after SKIP_AFTER — the customer never waits on us
       2. watchdog at BOOT_LIMIT — automatic bail to the static page
       3. per-image timeout in mch-karte3d.js — one bad asset ≠ dead cinema
     `settled` makes them mutually exclusive: whoever lands first wins, and a
     late boot resolve can't yank a customer back out of the static page. */
  var SKIP_AFTER = 6000;
  var BOOT_LIMIT = 30000;
  var settled = false;

  function bail(why) {
    if (settled) return;
    settled = true;
    clearTimeout(skipTimer);
    clearTimeout(bootTimer);
    dbg('BAIL: ' + why);
    staticMode(why);
    wireBuy(null);
  }

  /* Offer an out before the watchdog does. Reuses .play-skip, the same
     affordance the autoplay overlay already uses. */
  var skipTimer = setTimeout(function () {
    if (settled || !pre) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'play-skip pre-skip';
    b.textContent = 'Preskoči';
    b.addEventListener('click', function () { bail('user skipped'); });
    var inner = pre.querySelector('.pre-inner') || pre;
    inner.appendChild(b);
  }, SKIP_AFTER);

  var bootTimer = setTimeout(function () { bail('boot watchdog'); }, BOOT_LIMIT);

  eng.boot(
    {
      box: CFG.box,
      back: backEntry ? ((!mobile && backEntry.hd) || backEntry.file) : CFG.box.front,
      cards: cards
    },
    function (p) {
      if (progressEl) progressEl.style.transform = 'scaleX(' + p + ')';
      var pips = document.querySelectorAll('.pre-suits span');
      for (var i = 0; i < pips.length; i++) pips[i].classList.toggle('on', p * 4 >= i + 1);
    }
  ).then(function () {
      if (settled) { dbg('boot resolved after bail — ignored'); return; }
      settled = true;
      clearTimeout(skipTimer);
      clearTimeout(bootTimer);
      dbg('boot resolved, cards=' + eng.cards.length);
      ready();
    })
   .catch(function (e) { dbg('BOOT REJECTED: ' + (e && e.message || e)); console.error(e); bail('boot rejected'); });

  /* ============================================================
     formations — every target is computed from the live viewport
     ============================================================ */
  function V() { return { w: eng.worldW, h: eng.worldH, d: eng.dist }; }
  function zForHeightFrac(frac) {
    var v = V();
    return v.d * (1 - CARD.H / (frac * v.h));
  }

  /* stacked inside the box (standing, facing camera, packed on z);
     57 × 0.30 = 17.1mm — fits the 18mm interior like the real deck */
  function stackPos(i, n) {
    var z = -((n - 1) / 2) * 0.28 + i * 0.28;
    return { x: 0, y: -2, z: z };
  }

  /* dealer's fan — cards along an arc around a low pivot, like a hand fan */
  function fanPos(i, n) {
    var v = V();
    var t = n === 1 ? 0.5 : i / (n - 1);
    var spread = 0.94;                        /* ±54° */
    var a = (t - 0.5) * 2 * spread;
    var R = v.h * 0.50;
    var pivotY = -v.h * 0.38;
    return {
      x: Math.sin(a) * R,
      y: pivotY + Math.cos(a) * R,
      z: -14 + i * 0.55,
      rz: -a,
      ry: 0
    };
  }

  /* suit glyphs as FILLED silhouettes — constructive geometry (circles +
     wedges + stems), ascii-validated to read at 57 samples */
  function circIn(x, y, cx, cy, r) {
    var dx = x - cx, dy = y - cy;
    return dx * dx + dy * dy <= r * r;
  }
  function insideSuit(suit, x, y) {
    if (suit === 'spade') {
      if (circIn(x, y, -0.36, -0.22, 0.40) || circIn(x, y, 0.36, -0.22, 0.40)) return true;
      if (y >= -0.34 && y <= 1.02 && Math.abs(x) <= 0.74 * (1.02 - y) / 1.36) return true;
      return Math.abs(x) < 0.125 && y > -1.05 && y < -0.3;
    }
    if (suit === 'heart') {
      if (circIn(x, y, -0.36, 0.38, 0.42) || circIn(x, y, 0.36, 0.38, 0.42)) return true;
      return y <= 0.44 && y >= -1.05 && Math.abs(x) <= 0.80 * (y + 1.05) / 1.49;
    }
    if (suit === 'diamond') return Math.abs(x) / 0.72 + Math.abs(y) / 1.02 <= 1;
    if (suit === 'club') {
      var lob = [[0, 0.5, 0.42], [-0.44, -0.1, 0.42], [0.44, -0.1, 0.42]];
      for (var l = 0; l < 3; l++) {
        if (circIn(x, y, lob[l][0], lob[l][1], lob[l][2])) return true;
      }
      return Math.abs(x) < 0.12 && y > -1.05 && y < -0.3;
    }
    return false;
  }
  var GLYPHS = {};
  ['spade', 'diamond', 'club', 'heart'].forEach(function (suit) {
    var cand = [];
    for (var gx = -1.15; gx <= 1.15; gx += 0.085) {
      for (var gy = -1.15; gy <= 1.15; gy += 0.085) {
        if (insideSuit(suit, gx, gy)) cand.push({ x: gx, y: gy });
      }
    }
    /* farthest-point sampling → 57 points fill the whole silhouette */
    var pts = [];
    var cx = 0, cy = 0;
    cand.forEach(function (p) { cx += p.x; cy += p.y; });
    cx /= cand.length; cy /= cand.length;
    var seed = cand.reduce(function (best, p) {
      var d = (p.x - cx) * (p.x - cx) + (p.y - cy) * (p.y - cy);
      return d < best.d ? { p: p, d: d } : best;
    }, { p: cand[0], d: 1e9 }).p;
    pts.push(seed);
    while (pts.length < 57 && cand.length) {
      var far = null, farD = -1;
      cand.forEach(function (p) {
        var dMin = 1e9;
        pts.forEach(function (q) {
          var d = (p.x - q.x) * (p.x - q.x) + (p.y - q.y) * (p.y - q.y);
          if (d < dMin) dMin = d;
        });
        if (dMin > farD) { farD = dMin; far = p; }
      });
      pts.push(far);
    }
    GLYPHS[suit] = pts;
  });

  function glyphPos(suit, idx, count) {
    var v = V();
    var s = Math.min(v.w, v.h) * 0.335;
    var pts = GLYPHS[suit];
    var p = pts[idx % pts.length];
    return { x: p.x * s, y: p.y * s + v.h * 0.015, z: 40 - (idx % 5) * 6 };
  }

  /* dim ring for non-active cards during glyph + court acts */
  function ringPos(i, n) {
    var v = V();
    var a = (i / n) * Math.PI * 2 + (i % 3) * 0.35;
    var r = Math.max(v.w, v.h) * (0.58 + (i % 5) * 0.05);
    return { x: Math.cos(a) * r, y: Math.sin(a) * r * 0.72, z: -220 - (i % 7) * 40, rz: ((i % 7) - 3) * 0.12 };
  }

  /* golden-angle phyllotaxis wall, gold card at the heart */
  function wallPos(order, total) {
    var v = V();
    var rMax = 13.5 * Math.sqrt(total + 0.5);
    var fit = (Math.min(v.w, v.h * 1.06) * 0.5) / rMax;
    var r = order === 0 ? 0 : 13.5 * Math.sqrt(order + 0.5) * fit;
    var a = order * 2.39996323;
    return {
      x: Math.cos(a) * r,
      y: Math.sin(a) * r * 0.96,
      z: -order * 0.5,
      rz: ((order % 9) - 4) * 0.016,
      s: order === 0 ? 0.34 : Math.max(0.17, Math.min(0.23, fit * 0.16))
    };
  }

  /* ============================================================
     master timeline
     ============================================================ */
  var tl;

  function buildTimeline() {
    var n = eng.cards.length;
    var courts = ['k-spade', 'q-heart', 'j-club', 'a-diamond'];
    var suitsOrder = ['spade', 'diamond', 'club', 'heart'];
    var suitAccent = { spade: 0x9aa8ff, diamond: 0x53b7ff, club: 0x86d493, heart: 0xff8a5e };
    var byId = {};
    eng.cards.forEach(function (c) { byId[c.id] = c; });

    /* wall order: gold center, then courts, then the rest */
    var wallOrder = {};
    var seq = [];
    seq.push('star-gold');
    courts.forEach(function (id) { seq.push(id); });
    eng.cards.forEach(function (c) { if (seq.indexOf(c.id) === -1) seq.push(c.id); });
    seq.forEach(function (id, i) { wallOrder[id] = i; });

    tl = gsap.timeline({ paused: true, defaults: { ease: 'none' } });

    /* -- L0/L1 · hero exit + box showcase (0–14) -- */
    tl.to('#mchk-hero .hl-1', { yPercent: -130, opacity: 0, duration: 6, ease: 'power2.in' }, 0);
    tl.to('#mchk-hero .hl-2', { yPercent: 130, opacity: 0, duration: 6, ease: 'power2.in' }, 0);
    tl.to('#mchk-hero-ui, #mchk-cue', { opacity: 0, duration: 4, ease: 'power1.in' }, 0);
    tl.set('#mchk-hero-ui', { pointerEvents: 'none' }, 4);
    tl.to(eng, { bob: 0, duration: 5 }, 0);
    tl.fromTo(eng.spin.rotation, { y: -2.35, x: 0.06 }, { y: 0, x: 0, duration: 14, ease: 'power2.inOut' }, 0);
    tl.to(eng.camRig.rotation, { z: 0.0, duration: 1 }, 0);

    /* -- L2 · open (14–24) -- */
    tl.to(eng.flap.rotation, { x: -2.05, duration: 7, ease: 'power2.inOut' }, 14);
    tl.to(eng.lights.throat, { intensity: 2.4, duration: 5, ease: 'power2.in' }, 15);
    tl.to(eng.lights.throat, { intensity: 3.4, duration: 0.8, ease: 'power2.in' }, 20.2);
    tl.to(eng.lights.throat, { intensity: 1.1, duration: 3 }, 21.4);
    tl.to(eng.table.material, { opacity: 0.55, duration: 8 }, 16);

    /* -- L3 · deck rises, box exits (24–34); the deck is already visible
       inside the mouth while the flap opens -- */
    tl.to(eng.camBase, { y: 30, duration: 6, ease: 'power2.inOut' }, 15);
    tl.to(eng.camBase, { y: 0, duration: 6, ease: 'power2.inOut' }, 26);
    eng.cards.forEach(function (c, i) {
      var sp = stackPos(i, n);
      tl.set(c.group.position, { x: sp.x + ((i * 7) % 5 - 2) * 0.1, y: sp.y, z: sp.z }, 13.5);
      tl.set(c.group.rotation, { x: 0, y: Math.PI, z: ((i * 13) % 7 - 3) * 0.004 }, 13.5);  /* backs to camera, slight riffle */
      tl.set(c.group, { visible: true }, 13.5 + (i / n) * 0.3);
      tl.to(c.group.position, { y: 34, duration: 5.5, ease: 'power2.inOut' }, 25.3 + (i / n) * 0.55);
    });
    tl.to(eng.box.position, { y: -330, duration: 6.5, ease: 'power2.in' }, 26);
    tl.to(eng.table.material, { opacity: 0, duration: 5 }, 26.5);
    tl.to(eng.blob.material, { opacity: 0, duration: 4 }, 26.5);
    tl.to(eng.lights.throat, { intensity: 0, duration: 3 }, 27);
    tl.to(eng.scene.fog, { density: 0.0022, duration: 8 }, 27);

    /* -- L4 · dealer's fan (34–46), backs to the room -- */
    tl.to(eng.lights.hemi, { intensity: 0.78, duration: 4 }, 34);
    tl.to(eng.lights.key, { intensity: 1.5, duration: 4 }, 34);
    tl.to(eng.lights.hemi, { intensity: 0.55, duration: 3 }, 50);
    tl.to(eng.lights.key, { intensity: 1.25, duration: 3 }, 50);
    eng.cards.forEach(function (c, i) {
      var fp = fanPos(i, n);
      var d = Math.abs(i / (n - 1) - 0.5) * 2;
      tl.to(c.group.position, { x: fp.x, y: fp.y, z: fp.z, duration: 7.5, ease: 'power3.inOut' }, 35 + d * 2.6);
      tl.to(c.group.rotation, { z: fp.rz, duration: 7.5, ease: 'power3.inOut' }, 35 + d * 2.6);
      tl.to(c.group.scale, { x: 0.74, y: 0.74, z: 0.74, duration: 7 }, 35 + d * 2.6);
    });

    /* -- L5 · flip, a dealer's wave left → right (44–50) -- */
    eng.cards.forEach(function (c, i) {
      var t = i / (n - 1);
      tl.to(c.group.rotation, { y: 0, duration: 2.6, ease: 'back.out(1.3)' }, 44.5 + t * 2.6);
    });

    /* -- L6 · suit glyphs (50–66): ALL 57 cards form each silhouette; the
       active suit burns bright and forward, the rest recede inside it -- */
    suitsOrder.forEach(function (suit, si) {
      var at = 50 + si * 4;
      var accent = suitAccent[suit];
      tl.to(eng.lights.rim.color, {
        r: ((accent >> 16) & 255) / 255, g: ((accent >> 8) & 255) / 255, b: (accent & 255) / 255,
        duration: 2.4
      }, at);
      tl.to(eng.lights.rim, { intensity: 0.9, duration: 1.6, yoyo: true, repeat: 1 }, at);
      eng.cards.forEach(function (c, i) {
        var slot = (i * 23 + si * 11) % n;
        var gp = glyphPos(suit, slot, n);
        var active = c.suit === suit;
        tl.to(c.group.position, {
          x: gp.x, y: gp.y, z: gp.z + (active ? 26 : 0),
          duration: 2.2, ease: 'power3.inOut'
        }, at + (slot % 7) * 0.05);
        tl.to(c.group.rotation, { x: 0, y: 0, z: ((i % 9) - 4) * 0.03, duration: 2, ease: 'power2.inOut' }, at);
        var sc = active ? 0.205 : 0.165;
        tl.to(c.group.scale, { x: sc, y: sc, z: sc, duration: 2 }, at);
        setCardOpacity(tl, c, c.gold ? 0.14 : (active ? 1 : 0.14), 1.8, at + 0.2);
      });
    });

    /* -- L7 · court close-ups (66–78) -- */
    var heroZ = zForHeightFrac(mobile ? 0.5 : 0.56);
    tl.set(eng.halo, { visible: true }, 66);
    tl.set(eng.halo.position, { x: 0, y: 2, z: heroZ - 40 }, 66);
    tl.to(eng.halo.material, { opacity: 0.24, duration: 2.4 }, 66.4);
    tl.to(eng.halo.material, { opacity: 0, duration: 1.6 }, 77.4);
    tl.set(eng.halo, { visible: false }, 79.2);
    courts.forEach(function (id, ci) {
      var c = byId[id];
      if (!c) return;
      var at = 66 + ci * 3;
      var side = ci % 2 === 0 ? -1 : 1;
      tl.to(c.group.position, { x: side * (mobile ? 4 : eng.worldW * 0.0), y: 2, z: heroZ, duration: 2.6, ease: 'power3.inOut' }, at);
      tl.to(c.group.rotation, { x: -0.04, y: side * 0.16, z: side * 0.05, duration: 2.6, ease: 'power2.inOut' }, at);
      tl.to(c.group.scale, { x: 1, y: 1, z: 1, duration: 2.4 }, at);
      setCardOpacity(tl, c, 1, 1.5, at);
      if (ci > 0) {
        var prev = byId[courts[ci - 1]];
        tl.to(prev.group.position, { x: -side * eng.worldW * 0.7, y: eng.worldH * 0.42, z: heroZ - 60, duration: 2.8, ease: 'power2.in' }, at);
        tl.to(prev.group.rotation, { z: -side * 0.5, duration: 2.8 }, at);
      }
      /* on the first close-up the whole glyph disperses to a dim ring */
      eng.cards.forEach(function (o, i) {
        if (ci !== 0 || o.id === id || courts.indexOf(o.id) > 0) return;
        var rp3 = ringPos(i, n);
        tl.to(o.group.position, { x: rp3.x, y: rp3.y, z: rp3.z, duration: 3, ease: 'power2.inOut' }, at + (i % 5) * 0.1);
        tl.to(o.group.rotation, { z: rp3.rz, duration: 2.6 }, at);
        tl.to(o.group.scale, { x: 0.4, y: 0.4, z: 0.4, duration: 2.5 }, at);
        setCardOpacity(tl, o, o.gold ? 0.06 : 0.18, 2.5, at);
      });
    });
    /* last court exits before gold */
    var lastCourt = byId[courts[courts.length - 1]];
    tl.to(lastCourt.group.position, { x: eng.worldW * 0.7, y: eng.worldH * 0.4, z: heroZ - 80, duration: 2.6, ease: 'power2.in' }, 78);
    tl.to(lastCourt.group.rotation, { z: 0.5, duration: 2.6 }, 78);

    /* -- L8 · the golden card (78–90) -- */
    var gold = eng.goldCard;
    tl.to(eng.lights.hemi, { intensity: 0.08, duration: 4 }, 78);
    tl.to(eng.lights.key, { intensity: 0.2, duration: 4 }, 78);
    tl.to(eng.lights.rim, { intensity: 0.1, duration: 4 }, 78);
    tl.to('#mchk-veil', { opacity: 0.82, duration: 4 }, 78);
    eng.cards.forEach(function (c) {
      if (c.gold) return;
      setCardOpacity(tl, c, 0, 3.5, 78.4);
    });
    tl.set(eng.cone, { visible: true }, 80);
    tl.to(eng.cone.material, { opacity: mobile ? 0.2 : 0.26, duration: 3, ease: 'power2.in' }, 80);
    if (gold) {
      tl.to(gold.group.position, { x: 0, y: -2, z: 90, duration: 3.4, ease: 'power3.inOut' }, 80);
      tl.to(gold.group.rotation, { x: 0, z: 0, y: Math.PI, duration: 3, ease: 'power2.inOut' }, 80);
      tl.to(gold.group.scale, { x: 1.06, y: 1.06, z: 1.06, duration: 3 }, 80);
      setCardOpacity(tl, gold, 1, 2, 80);
      tl.set(eng, { foilOn: 1 }, 82);
      tl.to(gold.group.rotation, { y: 0, duration: 3.4, ease: 'back.out(1.1)' }, 84.2);
      tl.to(gold.front.uniforms.uBoost, { value: 1, duration: 1.6, ease: 'power2.in' }, 85);
      tl.to(gold.front.uniforms.uBoost, { value: 0.25, duration: 2.6 }, 87);
      tl.to(gold.group.position, { y: 4, duration: 3, ease: 'sine.inOut' }, 86);
    }
    /* deterministic burst */
    var burstProxy = { t: 0 };
    tl.set(eng.burst.points, { visible: true }, 85.4);
    tl.to(burstProxy, {
      t: 1, duration: 4.6,
      onUpdate: function () {
        var bt = burstProxy.t;
        var p = eng.burst.points.geometry.attributes.position.array;
        for (var i = 0; i < eng.burst.n; i++) {
          var v = eng.burst.vel[i];
          p[i * 3] = v[0] * bt;
          p[i * 3 + 1] = -2 + v[1] * bt - 60 * bt * bt;
          p[i * 3 + 2] = 90 + v[2] * bt;
        }
        eng.burst.points.geometry.attributes.position.needsUpdate = true;
        eng.burst.mat.opacity = bt < 0.12 ? bt / 0.12 : 1 - (bt - 0.12) / 0.88;
        eng.invalidate();
      }
    }, 85.4);

    /* -- L9 · phyllotaxis wall (90–96) -- */
    tl.to(eng.lights.hemi, { intensity: 0.5, duration: 3 }, 90);
    tl.to(eng.lights.key, { intensity: 0.9, duration: 3 }, 90);
    tl.to(eng.lights.rim, { intensity: 0.4, duration: 3 }, 90);
    tl.to('#mchk-veil', { opacity: 0.25, duration: 3 }, 90);
    tl.to(eng.cone.material, { opacity: 0, duration: 2 }, 90);
    tl.set(eng.cone, { visible: false }, 92.2);
    eng.cards.forEach(function (c) {
      var o = wallOrder[c.id];
      var wp = wallPos(o, n);
      var at = 90 + (o / n) * 2.0;
      tl.to(c.group.position, { x: wp.x, y: wp.y, z: wp.z, duration: 2.6, ease: 'power2.inOut' }, at);
      tl.to(c.group.rotation, { x: 0, y: 0, z: wp.rz, duration: 2.4 }, at);
      tl.to(c.group.scale, { x: wp.s, y: wp.s, z: wp.s, duration: 2.4 }, at);
      setCardOpacity(tl, c, 1, 1.8, at);
    });
    if (gold) tl.to(gold.front.uniforms.uBoost, { value: 0.55, duration: 2 }, 92);
    tl.to(eng.camRig.rotation, { z: 0.018, duration: 5, ease: 'sine.inOut' }, 90);
    tl.to(eng.camRig.rotation, { z: 0, duration: 3, ease: 'sine.inOut' }, 96);

    /* -- L10 · stream back into the box (96–100) -- */
    tl.to(eng.box.position, { y: 0, duration: 2.2, ease: 'power3.out' }, 96);
    tl.to(eng.table.material, { opacity: 1, duration: 2.5 }, 96.6);
    tl.to(eng.blob.material, { opacity: 0.85, duration: 2.5 }, 96.6);
    tl.to(eng.scene.fog, { density: 0.0016, duration: 3 }, 96);
    eng.cards.forEach(function (c) {
      var o = wallOrder[c.id];
      var at = 96.3 + (1 - o / n) * 2.0;      /* outermost first, gold last */
      tl.to(c.group.position, { x: 0, y: 52, z: 2, duration: 1.1, ease: 'power2.in' }, at);
      tl.to(c.group.rotation, { x: 0, y: 0, z: 0, duration: 1.0 }, at);
      tl.to(c.group.scale, { x: 0.55, y: 0.55, z: 0.55, duration: 1.0 }, at);
      tl.to(c.group.position, { y: 24, duration: 0.35, ease: 'power1.in' }, at + 1.1);
      setCardOpacity(tl, c, 0, 0.3, at + 1.2);
      tl.set(c.group, { visible: false }, at + 1.5);
    });
    tl.set(eng, { foilOn: 0 }, 97);
    tl.to(eng.flap.rotation, { x: 0, duration: 1.0, ease: 'power2.inOut' }, 98.9);
    tl.to(eng.spin.rotation, { x: 0.1, y: -0.14, duration: 2, ease: 'power2.out' }, 98);
    tl.to(eng.lights.key, { intensity: 1.25, duration: 2 }, 98);
    tl.to(eng.lights.throat, { intensity: 1.4, duration: 1.2 }, 96.5);
    tl.to(eng.lights.throat, { intensity: 0, duration: 1 }, 99);

    tl.eventCallback('onUpdate', function () { eng.invalidate(); });
    return tl;
  }

  /* opacity helper: cards are two meshes (front std/shader + back std) */
  function setCardOpacity(tline, card, value, dur, at) {
    tline.to(card.back, { opacity: value, duration: dur }, at);
    if (card.gold) {
      tline.to(card.front.uniforms.uOpacity, { value: value, duration: dur }, at);
      tline.to(card.front.uniforms.uFoil, { value: value > 0.5 ? 1 : 0.1, duration: dur }, at);
    } else {
      tline.to(card.front, { opacity: value, duration: dur }, at);
    }
  }

  /* ============================================================
     boot → intro → scroll wiring
     ============================================================ */
  function ready() {
    if (pre) {
      pre.classList.add('done');
      setTimeout(function () { pre.remove(); }, 650);
    }
    body.classList.add('mchk-ready');

    buildTimeline();

    /* ?tl=0..1 — screenshot harness: no ScrollTrigger, page stays at scroll 0,
       the master timeline is driven directly. Visuals are identical because
       the stage is sticky-fullscreen at scroll 0. */
    var tlp = parseFloat(qs.get('tl'));
    if (!isNaN(tlp)) {
      if (qs.get('buy') === '1') document.getElementById('mchk-scroll').style.display = 'none';
      document.getElementById('mchk-cue').style.opacity = 0;
      var setTl = function (p) {
        tl.progress(Math.max(0, Math.min(1, p)));
        if (p > 0.02) {
          gsap.set('#mchk-hero .hl-1', { yPercent: -130, opacity: 0 });
          gsap.set('#mchk-hero .hl-2', { yPercent: 130, opacity: 0 });
          gsap.set('#mchk-hero-ui', { opacity: 0 });
        }
        eng.camRig.position.x = eng.camBase.x;   /* snap (no rAF in harness) */
        eng.camRig.position.y = eng.camBase.y;
        eng.render();
        return 'tl=' + p;
      };
      window.MCHK_DEBUG = { eng: eng, tl: tl, jumpTl: setTl };
      setTl(tlp);
      setTimeout(function () { setTl(tlp); }, 350);
      wireBuy(eng);
      return;
    }

    var fast = qs.get('fast') === '1';
    var st = ScrollTrigger.create({
      trigger: pinWrap,
      start: 'top top',
      end: 'bottom bottom',
      scrub: fast ? true : 1.1,
      animation: tl,
      invalidateOnRefresh: false,
      onUpdate: function (self) {
        var p = self.progress;
        var rail = document.getElementById('mchk-rail');
        if (rail) {
          var acts = [0.14, 0.5, 0.78, 0.9];
          var idx = 0;
          for (var i = 0; i < acts.length; i++) if (p >= acts[i]) idx = i + 1;
          if (+rail.dataset.act !== idx) {
            rail.dataset.act = idx;
            var pips = rail.querySelectorAll('button');
            for (var k = 0; k < pips.length; k++) pips[k].classList.toggle('on', k < idx);
          }
        }
        var th = document.getElementById('mchk-thread');
        if (th) th.style.transform = 'scaleY(' + p + ')';
      }
    });

    /* header day/night: dark glass over the stage, Signal paper over buy */
    ScrollTrigger.create({
      trigger: '#mchk-buy',
      start: 'top 72%',
      onEnter: function () { body.classList.remove('mchk-night'); },
      onLeaveBack: function () { body.classList.add('mchk-night'); }
    });

    /* pip rail → jump */
    var rail = document.getElementById('mchk-rail');
    if (rail) {
      var targets = [0.0, 0.36, 0.66, 0.83, 1.06];
      Array.prototype.forEach.call(rail.querySelectorAll('button'), function (b, i) {
        b.addEventListener('click', function () {
          var y = st.start + (st.end - st.start) * targets[i];
          window.scrollTo({ top: Math.min(y, document.body.scrollHeight), behavior: 'smooth' });
        });
      });
    }

    /* intro (skips if the page loads mid-scroll or a ?p= jump is requested) */
    var pjump = parseFloat(qs.get('p'));
    var intro = null;
    if (st.progress < 0.02 && isNaN(pjump)) {
      intro = gsap.timeline();
      intro.fromTo(eng.box.position, { y: -260 }, { y: 0, duration: 1.5, ease: 'power3.out' }, 0.1);
      intro.fromTo(eng.spin.rotation, { y: -3.4 }, { y: -2.35, duration: 1.6, ease: 'power2.out' }, 0.1);
      intro.fromTo('#mchk-hero .hl-1', { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out' }, 0.4);
      intro.fromTo('#mchk-hero .hl-2', { yPercent: -60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out' }, 0.5);
      intro.fromTo('#mchk-hero-ui .hero-eyebrow, #mchk-hero-ui .hero-meta', { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.7, stagger: 0.12 }, 0.75);
      intro.fromTo('#mchk-cue', { opacity: 0 }, { opacity: 1, duration: 0.6 }, 1.3);
      intro.eventCallback('onUpdate', function () { eng.invalidate(); });
    }

    /* pointer parallax (desktop only) */
    if (!mobile) {
      eng.parallax.on = true;
      window.addEventListener('pointermove', function (e) {
        var nx = (e.clientX / window.innerWidth - 0.5);
        var ny = (e.clientY / window.innerHeight - 0.5);
        eng.parallax.x = nx * 7;
        eng.parallax.y = -ny * 5;
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      eng.setViewport();
      eng.invalidate();
    });

    /* debug jump (?p=0..1 over the pin; >1 lands in the buy section) —
       applied synchronously and re-applied on load so throttled tabs still
       paint the right frame */
    function applyJump() {
      if (isNaN(pjump)) return;
      var y = pjump > 1
        ? document.getElementById('mchk-buy').offsetTop + (pjump - 1) * window.innerHeight * 4
        : st.start + (st.end - st.start) * Math.max(0, Math.min(1, pjump));
      for (var i = 0; i < 5 && Math.abs(window.scrollY - y) > 2; i++) {
        window.scrollTo(0, y);
        ScrollTrigger.update();
      }
      if (pjump <= 1) tl.progress(Math.max(0, Math.min(1, pjump)));
      eng.render();
    }
    if (!isNaN(pjump)) {
      applyJump();
      setTimeout(applyJump, 300);
      window.addEventListener('load', function () { setTimeout(applyJump, 60); });
    } else {
      window.scrollTo(0, 0);
      ScrollTrigger.update();
    }

    wireBuy(eng);
    wireAutoplay(st, tl, eng, intro);

    /* debug handle for scripted screenshot sweeps (rAF-independent) */
    window.MCHK_DEBUG = {
      st: st, tl: tl, eng: eng,
      jump: function (p) {
        if (intro && intro.progress() < 1) intro.progress(1);
        var y = p > 1
          ? document.getElementById('mchk-buy').offsetTop + (p - 1) * window.innerHeight * 4
          : st.start + (st.end - st.start) * Math.max(0, Math.min(1, p));
        for (var i = 0; i < 5 && Math.abs(window.scrollY - y) > 2; i++) {
          window.scrollTo(0, y);
          ScrollTrigger.update();
        }
        if (p <= 1) tl.progress(Math.max(0, Math.min(1, p)));
        eng.render();
        return JSON.stringify({ p: +st.progress.toFixed(3), y: window.scrollY });
      }
    };
  }

  /* ============================================================
     buy section — mini box viewer + qty + cart
     ============================================================ */
  function wireBuy(mainEng) {
    var mount = document.getElementById('mchk-buybox');
    if (mount && window.THREE && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          io.disconnect();
          MCHK3D.createBuy(mount, {
            front: CFG.box.front, back: CFG.box.back, left: CFG.box.left, right: CFG.box.right,
            backCard: CFG.box.front
          });
        }
      }, { rootMargin: '300px' });
      io.observe(mount);
    }

    var qty = document.getElementById('mchk-qty');
    document.querySelectorAll('.js-qminus').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    });
    document.querySelectorAll('.js-qplus').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.min(20, (parseInt(qty.value, 10) || 1) + 1); });
    });

    var form = document.getElementById('mchk-form');
    if (form && CFG.shopify && window.MCHcart) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.js-add');
        if (btn) btn.classList.add('busy');
        window.MCHcart.add([{ id: CFG.variantId, quantity: parseInt(qty.value, 10) || 1 }])
          .then(function () {
            if (window.MCHtoast) window.MCHtoast('<span class="ok">✓</span> Špil je u korpi');
            window.MCHcart.open();
          })
          .catch(function (err) {
            if (window.MCHtoast) window.MCHtoast('<span class="err">✕</span> ' + (err && err.message || 'Greška.'));
          })
          .then(function () { if (btn) btn.classList.remove('busy'); });
      });
    } else if (form && !CFG.shopify) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.js-add');
        if (btn) { btn.classList.add('busy'); setTimeout(function () { btn.classList.remove('busy'); }, 700); }
        console.log('[sandbox] add to cart', qty ? qty.value : 1);
      });
    }

    /* hero CTA scrolls to buy */
    document.querySelectorAll('.js-tobuy').forEach(function (b) {
      b.addEventListener('click', function () {
        document.getElementById('mchk-buy').scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ============================================================
     autoplay — the whole cinema hands-free, landing on buy.
     ScrollTrigger is disabled for the duration and the master
     timeline is driven directly: one scrub per frame, identical to
     the cost of scrolling, and it never fights the scroller (which
     is what makes programmatic smooth-scroll approaches stutter on
     iOS). Input is blocked rather than locking the body, so the
     document height never changes under ScrollTrigger.
     ============================================================ */
  function wireAutoplay(st, tline, engine, intro) {
    var btn = document.querySelector('.js-autoplay');
    var hud = document.getElementById('mchk-play');
    if (!btn || !st || !tline) return;

    var bar = hud ? hud.querySelector('.play-track i') : null;
    var skip = hud ? hud.querySelector('.js-skip') : null;
    var buy = document.getElementById('mchk-buy');
    var secs = parseFloat(btn.getAttribute('data-seconds'));
    if (!secs || secs < 5) secs = 26;

    var PAGE_KEYS = [' ', 'Spacebar', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
    var proxy = { p: 0 };
    var play = null;

    function block(e) { e.preventDefault(); }
    function onKey(e) {
      if (e.key === 'Escape') { end(false); return; }
      if (PAGE_KEYS.indexOf(e.key) > -1) e.preventDefault();
    }
    function listen(on) {
      var m = on ? 'addEventListener' : 'removeEventListener';
      window[m]('wheel', block, { passive: false });
      window[m]('touchmove', block, { passive: false });
      window[m]('keydown', onKey, false);
    }

    function end(toBuy) {
      if (!play) return;
      play.kill();
      play = null;
      listen(false);
      body.classList.remove('mchk-playing');
      if (hud) hud.hidden = true;
      /* move the scroller to where the timeline already sits BEFORE
         re-arming ScrollTrigger, or it snaps the cinema back to frame 0 */
      if (toBuy && buy) window.scrollTo(0, buy.offsetTop);
      st.enable();
      ScrollTrigger.update();
      engine.invalidate();
    }

    btn.addEventListener('click', function () {
      if (play) return;
      if (intro && intro.progress() < 1) intro.progress(1);
      window.scrollTo(0, st.start);
      st.disable(false, true);
      body.classList.add('mchk-playing');
      if (hud) hud.hidden = false;
      if (bar) bar.style.transform = 'scaleX(0)';
      listen(true);
      proxy.p = 0;
      tline.progress(0);
      engine.invalidate();
      play = gsap.to(proxy, {
        p: 1, duration: secs, ease: 'none',
        onUpdate: function () {
          tline.progress(proxy.p);
          if (bar) bar.style.transform = 'scaleX(' + proxy.p + ')';
          engine.invalidate();
        },
        onComplete: function () { end(true); }
      });
    });

    if (skip) skip.addEventListener('click', function () { end(true); });
  }
})();
